import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/69ab04474fab3d0014742b2e/globalvarsity/src/app/not-found.tsx");
